export default __webpack_public_path__ + "static/media/mysql-6.0697e026.svg";